import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    templateUrl: './schedule-route-directions-page.component.html'
})
export class ScheduleRouteDirectionsPageComponent extends BaseComponent implements OnInit, OnDestroy {
    routeId = null;

    constructor(private route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            this.routeId = params['routeId'];
        });
    }
}
